/* eslint-disable @typescript-eslint/no-empty-function */
import { config } from '@app/config';
import { GrowthBook } from '@growthbook/growthbook-react';

let growthbook: GrowthBook;

if (config.isTest) {
  // mock growthBook
  growthbook = {
    ready: true,
    debug: false,
    version: '1.0.0',
    isOn: () => false,
    isOff: () => true,
    getFeatureValue: (key: string, defaultValue: any) => defaultValue,
    evalFeature: () => ({ value: null, source: 'defaultValue' }),
    feature: () => ({ value: null, source: 'defaultValue' }),
    run: () => ({ value: null, source: 'defaultValue' }),
    getAttributes: () => ({}),
    getFeatures: () => ({}),
    getForcedVariations: () => ({}),
    getURL: () => '',
    loadFeatures: async () => ({}),
    setAttributes: () => {},
    setForcedVariations: () => {},
    setURL: () => {},
    destroy: () => {},
    init: async () => ({}),
    subscribe: () => () => {},
    setRenderer: () => {},
    track: () => {},
    setEncryptionKey: () => {},
    setAnonymousId: () => {},
    getAnonymousId: () => '',
    setQAMode: () => {},
    isQAMode: () => false,
    setDevMode: () => {},
    isDevMode: () => false,
  } as unknown as GrowthBook;
} else {
  growthbook = new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: config.growthbookClientKey,
    enabled: !!config.growthbookClientKey,
  });
}

export { growthbook };
